
//Import
import React from 'react'
import styled from 'styled-components'
import styles from './ModalContainer_styles'

// Componente base
const ModalContainer_base = ({...props}) => {
    return (
        <div {...props}>
            {props.children}
        </div>
    )
}
const ModalContainer = styled(ModalContainer_base)`${ styles }`
export default ModalContainer
